import React from 'react';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Button } from '@heroui/react';
import { useSidebar } from './sidebar-provider';
import { useLanguage } from '../../stores/language-store';

export const SidebarHeader: React.FC = () => {
  const { t } = useTranslation();
  const { isMini, isMobile, toggleSidebar } = useSidebar();
  const { isRTL } = useLanguage();

  return (
    <div className="flex items-center justify-between h-16 px-4 border-b border-gray-200 dark:border-gray-800">
      {!isMini && (
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg ">
            <img 
              src="/svg/logo-nav.svg" 
              alt="Logo"
              className="w-full h-full invert dark:invert-0" 
            />
          </div>
          <motion.div
            initial={{ opacity: 0, x: isRTL ? 10 : -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.2 }}
          >
            <h1 className="text-lg font-semibold text-gray-900 dark:text-white">
              {t('appName')}
            </h1>
          </motion.div>
        </div>
      )}
      
      {isMini && (
        <div className="flex justify-center w-full">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg">
            <img 
              src="/svg/logo-nav.svg" 
              alt="Logo"
              className="w-full h-full invert dark:invert-0" 
            />
          </div>
        </div>
      )}
      
      {!isMini && isMobile && (
        <Button 
          isIconOnly 
          variant="light"
          size="sm"
          onPress={toggleSidebar}
        >
          <Icon icon="lucide:x" width={18} />
        </Button>
      )}
    </div>
  );
};